import { render, staticRenderFns } from "./Blockchain.vue?vue&type=template&id=f6bdcf8e&scoped=true&"
import script from "./Blockchain.vue?vue&type=script&lang=ts&"
export * from "./Blockchain.vue?vue&type=script&lang=ts&"
import style0 from "./Blockchain.vue?vue&type=style&index=0&id=f6bdcf8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bdcf8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
